import type { QueryKey } from "@tanstack/react-query"

import type { TranslationObj } from "$/utils/lang"

import type { IUserParticipantModel } from "@/3514/types"

enum EPostSessionModalMode {
    ManualFeedback = "manualFeedback",
    PastReflection = "pastReflection"
}

type TPostSessionModalProps = {
    user: IUserParticipantModel
    sessionId: number
    moduleId: number
    moduleTitle: TranslationObj
    mode: EPostSessionModalMode
    sessionsQueryKey: QueryKey
}

type TPostSessionModalButtonSubmitState = {
    isCoachRatingSubmittable: boolean
    isLikertSubmittable: boolean
}

type TPostSessionSubmitModuleReflectionMutationPayloadUiState = {
    reflectionAnswers: { questionUuid: string; answer: string }[]
    likertAnswers: { questionUuid: string; optionUuid: string; order: number }[]
}

export { EPostSessionModalMode }
export type {
    TPostSessionModalProps,
    TPostSessionModalButtonSubmitState,
    TPostSessionSubmitModuleReflectionMutationPayloadUiState
}
